(function () {
    "use strict";

    HPredefinedSetsBrandNavigatorComponent.$inject = ['hUser', '$modal', '$q', 'brandsPredefinedSetsService', '$stateParams'];

    function HPredefinedSetsBrandNavigatorComponent(hUser, $modal, $q, brandsPredefinedSetsService, $stateParams) {
        const self = this;
        const cachedBrandsTrees = {};

        self.filter = 'hays';
        self.initialTree = [];
        self._brandMappings = {};
        self.selectedSet = null;
        self._selected = [];
        self.loading = false;
        self.show = true;

        function applyPredefinedLocations(locationIds) {
            if (!locationIds?.length) return;

            const tree = BrandNavigatorUtils.buildSelectedBrandsTree(locationIds);

            self.initialTree = angular.copy(tree);
            self._selected = angular.copy(locationIds);
            self.toggle = !self.toggle;
            self.apply();
        }

        const init = () => {
            self.groupId = hUser.getUserContext().brand_id;
            self.selectedSet = null;
            self.filter = '';
            self.loading = true;

            brandsPredefinedSetsService
                .getPredefinedSets(self.groupId)
                .then(result => {
                    self.predefinedSets = _.sortBy(result, item => item.title);
                })
                .catch(error => {
                    self.predefinedSets = [];
                    console.error(error);
                })
                .finally(() => {
                    self.loading = false;
                });

            let locationIds;
            try {
                locationIds = JSON.parse(localStorage.getItem($stateParams.location_ids));
            } catch (e) {
                return;
            }

            if (locationIds) {
                applyPredefinedLocations(locationIds);
            }
        };

        const getSetBrands = function () {
            const setBrands = [];

            self._selected.forEach(brand => {
                const setBrand = {
                    id: brand.id,
                    name: brand.name,
                    type: brand.type,
                    include_children: !!brand.include_children,
                    parents_ids: BrandNavigatorUtils.getParentIdsFromMapping(
                        self._brandMappings,
                        brand.brand_id || brand.id
                    )
                };

                setBrands.push(setBrand);
            });

            return setBrands;
        };

        self.$onInit = function () {
            init();
        };

        self.$onChanges = (changesObj) => {
            if (changesObj.selected) {
                const selected = self.selected || [];
                const newSelected = selected.map(item => item.id).sort();
                const localSelected = self._selected.map(item => item.id).sort();

                let changed = false;
                if (newSelected.length !== localSelected.length) {
                    changed = true;
                }

                if (!changed && JSON.stringify(newSelected) !== JSON.stringify(localSelected)) {
                    changed = true;
                }

                if (changed) {
                    self._selected = angular.copy(selected);
                }
            }

            const preparedSelectedBrandsC = changesObj?.preparedSelectedBrands?.currentValue;
            const preparedSelectedBrandsP = changesObj?.preparedSelectedBrands?.previousValue;
            if (preparedSelectedBrandsC &&
                JSON?.stringify(preparedSelectedBrandsC) !== JSON?.stringify(preparedSelectedBrandsP)) {
                applyPredefinedLocations(preparedSelectedBrandsC);
            }
        };

        self.$onDestroy = function () {
        };

        self.applySet = (set) => {
            const tree = BrandNavigatorUtils.buildSelectedBrandsTree(set.brands);

            self.selectedSet = set;
            self.initialTree = angular.copy(tree);
            self._selected = angular.copy(set.brands);
            self.toggle = !self.toggle;
            self.onChange({selected: angular.copy(self._selected)});
        };

        self.edit = (predefinedSet) => {
            const modalData = () => {
                return {
                    groupId: self.groupId,
                    predefinedSet: predefinedSet,
                    onChange: () => {
                        init();
                    }
                };
            };

            $modal(getBrandsPredefinedSetEditModal(modalData));
        };

        self.save = () => {
            const modalData = () => {
                return {
                    groupId: self.groupId,
                    brands: getSetBrands(),
                    predefinedSets: self.predefinedSets,
                    onChange: () => {
                        init();
                    }
                };
            };

            $modal(getBrandsPredefinedSetSaveModal(modalData));
        };

        self._onLoadBrand = (brandId) => {
            const defer = $q.defer();

            if (cachedBrandsTrees[brandId]) {
                defer.resolve(angular.copy(cachedBrandsTrees[brandId]));
                return defer.promise;
            }

            self.onLoadBrand({brandId: brandId})
                .then((tree) => {
                    cachedBrandsTrees[brandId] = angular.copy(tree);
                    defer.resolve(tree);
                })
                .catch((err) => {
                    console.error(err);
                    defer.reject(err);
                });

            return defer.promise;
        };

        self._onBrandMappingsChange = (brand_mappings) => {
            self._brandMappings = angular.copy(brand_mappings);
            self.onBrandMappingsChange({brand_mappings: brand_mappings});
        };

        self._ngChange = () => {
            self.selectedSet = null;
            self.onChange({selected: angular.copy(self._selected)});
        };

        self.onInitTree = () => {
            if (!self.initialTree.length) {
                return;
            }

            const defer = $q.defer();
            defer.resolve(angular.copy(self.initialTree));
            return defer.promise;
        };

        self.apply = () => {
            self.onApply({
                selected: angular.copy(self._selected),
                set: angular.copy(self.selectedSet),
                preparedSelectedBrands: getSetBrands()
            });
        };

        self._closedLocationsToggleChanged = (includeArchived) => {
            self.onClosedLocationsToggleChanged({
                includeArchived: includeArchived
            });
        }
    }

    const HPredefinedSetsBrandNavigatorComponentOptions = {
        transclude: true,
        bindings: {
            onApply: '&',
            name: '@',
            selected: '<',
            brandId: '<',
            singleSelect: '<',
            onLoadBrand: '&',
            onChange: '&',
            separateEnterprise: '<',
            alwaysCheckRoot: '<',
            preparedSelectedBrands: '<',
            onBrandMappingsChange: '&',
            brandMappings: '<',
            showClosedLocationsToggle: '<',
            onClosedLocationsToggleChanged: '&',
            enterpriseLevelOnly: '<',
            showClosedLocationsToggle: '<',
            includeArchivedLocations: '<',
            onClosedLocationsToggleChanged: '&',
        },
        controller: HPredefinedSetsBrandNavigatorComponent,
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/brands-predefined-sets/components/h-predefined-sets-brand-navigator/h-predefined-sets-brand-navigator.component.html'
    };

    angular
        .module('harriMainApp')
        .component('hPredefinedSetsBrandNavigator', HPredefinedSetsBrandNavigatorComponentOptions);
})();


